import { ColumnDef } from "@tanstack/react-table";
import { useLanguage } from "hooks";
import moment from "moment";
/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ItemsTable, PersonInfo } from "ui";

import { PriceInsightOrdersListItem } from "../../insights.types";
import { PriceInsightOrdersTableProps } from "./PriceInsightsTable.types";

import styles from "./PriceInsightsTable.module.scss";

const PriceInsightOrdersTable = ({
  orders = [],
  sorting,
  setSorting,
  isLoading
}: PriceInsightOrdersTableProps) => {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  const columns: Array<
    ColumnDef<PriceInsightOrdersListItem, PriceInsightOrdersListItem[]>
  > = useMemo(
    () => [
      {
        id: "resellerFullName",
        accessorKey: "resellerFullName",
        header: t("Reseller"),
        size: 40,
        minSize: 40,
        cell: ({ row }) => (
          <PersonInfo
            image={orders[row.index].reseller.image}
            personName={`${orders[row.index].reseller.firstname} ${orders[row.index].reseller.lastname}`}
            bottomText={`${orders[row.index].reseller.id}`}
            nameClassName={styles.table_resellerName}
            bottomTextClassName={styles.table_resellerId}
            dimensions={{ width: 32, height: 32, borderRadius: "100%" }}
          />
        )
      },
      {
        header: t("Size"),
        size: 20,
        minSize: 20,
        cell: ({ row }) => orders[row.index].sizeAttributeValue.value
      },
      {
        id: "soldPrice",
        accessorKey: "soldPrice",
        header: t("Sold Price"),
        size: 20,
        minSize: 20,
        cell: ({ row }) => orders[row.index].soldPrice.toLocaleString("en-US")
      },
      {
        id: "soldAt",
        accessorKey: "soldAt",
        header: t("Sold Date"),
        size: 20,
        minSize: 20,
        cell: ({ row }) => (
          <pre>
            {`${moment(orders[row.index].soldAt).format("DD/MM/YYYY")}`}
            {"\n"}
            {`${moment(orders[row.index].soldAt).format("HH:mm")}`}
          </pre>
        )
      }
    ],
    [orders, currentLanguage]
  );

  return (
    <ItemsTable
      className={styles.table}
      columns={columns}
      data={orders}
      sorting={sorting}
      skeletonHeight={60}
      setSorting={setSorting}
      isLoading={isLoading}
    />
  );
};

export default PriceInsightOrdersTable;
